// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"227":"5bd0ba0a40fc92c8","380":"8fa57f6096502ee9","496":"c9753d35177e3c67","828":"5a98222eea9ea40e","855":"1a1451267c0e8460","879":"da6242568ade38bc"}[chunkId] + ".js";
};